import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import {
  FormGroup,
  ControlLabel,
  Checkbox,
} from 'react-bootstrap';

import {
  dispatchDistrict, setUserDefaultDistrictId,
  advancedBonusTicketFiltering,
} from '../actions';
import { getDistrictId, getShowProcessed } from '../selectors';
import DistrictFilter from '../../fields/DistrictFilter';
import TicketListEnhanced from './TicketListEnhanced';
import BonusPeriodEnhanced from './BonusPeriodEnhanced';
import { queryGetAllBonusMonthsGQL } from '../graphql/allBonusMonthApi';


const propTypes = exact({
  currentDistrictId: PropTypes.number,
  dispatchDistrictAction: PropTypes.func.isRequired,
  showProcessed: PropTypes.bool.isRequired,
  allBonusMonths: PropTypes.array.isRequired,
  advancedBonusTicketFilteringAction: PropTypes.func.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  setUserDefaultDistrictIdAction: PropTypes.func.isRequired,
  /* eslint-enable react/no-unused-prop-types */
});

const ListPanel = (props) => {
  const {
    currentDistrictId,
    dispatchDistrictAction,
    allBonusMonths,
    showProcessed,
    advancedBonusTicketFilteringAction,
  } = props;

  const handleToggleCheckbox = (e) => {
    const { target: { checked } } = e;
    advancedBonusTicketFilteringAction(checked, allBonusMonths);
  };

  return (
    <div>
      <FormGroup>
        <ControlLabel className="control-label">
          District:
        </ControlLabel>
        <DistrictFilter
          name="Field District"
          value={{ id: currentDistrictId }}
          onChange={dispatchDistrictAction}
        />
      </FormGroup>

      <Checkbox
        checked={showProcessed}
        inline
        onClick={(e) => { return handleToggleCheckbox(e); }}
      >
        <ControlLabel className="control-label">Show All Tickets</ControlLabel>
      </Checkbox>
      {showProcessed && (
        <div>
          <FormGroup>
            <ControlLabel className="control-label">
              Bonus Period:
            </ControlLabel>
            <BonusPeriodEnhanced allBonusMonths={allBonusMonths} />
          </FormGroup>

        </div>
      )}
      <FormGroup />
      <h4>Ticket Numbers</h4>
      <div style={{ maxHeight: '52vh', overflow: 'auto' }}>
        <TicketListEnhanced />
      </div>
    </div>
  );
};


ListPanel.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    currentDistrictId: getDistrictId(state),
    showProcessed: getShowProcessed(state),
  };
};


const mapDispatchToProps = {
  dispatchDistrictAction: dispatchDistrict,
  setUserDefaultDistrictIdAction: setUserDefaultDistrictId,
  advancedBonusTicketFilteringAction: advancedBonusTicketFiltering,
};

const withInitPage = lifecycle({
  componentWillMount() {
    const { showProcessed } = this.props;

    if (!showProcessed) {
      this.props.setUserDefaultDistrictIdAction();
    }
  },
});


const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
  queryGetAllBonusMonthsGQL,
);

export default enhance(ListPanel);
